/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';

import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Modal,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { DeleteOutline } from '@material-ui/icons';
import { Alert, Pagination } from '@material-ui/lab';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Button from 'components/Button/button';
import ItemsPerPage from 'components/ItemsPerPage';
import PageTitleAndFilter from 'components/PageTitleAndFilter';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import AddIcon from 'images/icons/signals/addsAndCreates/add.svg';
import DiscardTypeForm from 'pages/admin/types-discard/Register';
import * as DiscardsActions from 'store/actions/discards';
import { GlobalStyle, Container } from 'styles/general';
import Environment from 'utils/environments';
import ValidationLength from 'utils/utils';

function TipoDeDescarte({ userInfo, setDiscards, createDiscards }) {
  const environments = Environment(process.env.REACT_APP_ENV);
  const [callSettings, setCallSettings] = useState({
    getId: userInfo.companiesActive.id,
    page: 1,
    totalPages: 0,
    size: 100,
    mainContent: [],
    numberOfElements: 0,
    loading: true,
    totalElements: 0
  });
  const {
    getId,
    page,
    size,
    totalPages,
    mainContent,
    numberOfElements,
    loading,
    totalElements
  } = callSettings;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [state, setState] = useState('');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [deleteData, setDeleteData] = useState();
  const [deleteSuccess, handleDeleteSuccess] = useState(false);
  const [deleteError, handleDeleteError] = useState(false);
  const [discardTypeModal, setDiscardTypeModal] = useState(false);
  const [updateList, setUpdateList] = useState(false);
  const userLocal = JSON.parse(localStorage.getItem('companies'));

  const validGroup = userInfo.companiesActive.id.length > 0

  function removeDuplicate(array) {
    const uniqueMap = {};
    return array.filter(obj => {
        const key = JSON.stringify(obj);
        return uniqueMap.hasOwnProperty(key) ? false : (uniqueMap[key] = true);
    });
  }

  const handleDialogClickOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  function handleCloseAll(handle) {
    handle(false);
  }

  // Get Tipo de Descarte
  useEffect(() => {
    (async () => {
      setCallSettings({ ...callSettings, loading: true });
      const response = await fetch(
        `${environments.catalogV2}/discards${getId?.[1] ? '/groups' : ''}?size=${size}&page=${page}&originId=${getId}`
      );
      const typeDiscards = await response.json();
      setCallSettings({
        ...callSettings,
        totalPages: typeDiscards?.totalPages,
        mainContent: typeDiscards?.content || [],
        numberOfElements: typeDiscards?.numberOfElements,
        loading: false,
        totalElements: typeDiscards?.totalElements
      });
    })();
  }, [getId, page, updateList]);

  useEffect(() => {
    setCallSettings({ ...callSettings, getId: userInfo.companiesActive.id });
  }, [userInfo]);

  // Delete
  function handleDelete() {
    new Promise((resolve, reject) => {
      const baseUrl = `${environments.catalog}/discards`;
      const data = mainContent;
      const index = data.indexOf(deleteData);
      mainContent.splice(index, 1);
      setState(mainContent);

      axios
        .delete(`${baseUrl}/${deleteData.id}`, {
          method: 'DELETE',
          user: userInfo.user,
          headers: {
            User: `${userLocal?.user}`
          }
        })
        .then((response) => {
          resolve();
          handleDialogClose();
          handleDeleteSuccess(true)
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  }

  const toggleDiscardTypeModal = () => {
    setDiscardTypeModal(!discardTypeModal);

    if (discardTypeModal === false) {
      setUpdateList(false);
    }
  };

  const addDiscard = () => (
    <Tooltip title="Cadastrar Tipo de Descarte" aria-label="add">
      <IconButton
        className="p0"
        color="primary"
        aria-label="upload picture"
        component="span"
        onClick={() => {
          toggleDiscardTypeModal();
          createDiscards();
        }}
      >
        <img style={{ width: '25px' }} src={AddIcon} alt="AddIcon" />
      </IconButton>
    </Tooltip>
  );
  
  return (
    <Layout>
      <TitleHead title="Tipo de Descarte" />

      <GlobalStyle />
      
      <Container>
        <PageTitleAndFilter
          title="Tipo de Descarte"
          additionalbutton={addDiscard}
        />

        <table
          className="desktop"
          width="100%"
          cellPadding="0"
          cellSpacing="0"
          border="0"
        >
          <thead>
            <tr className="headerTitle">
              <th width="30%" className="subtitle">
                DESCRIÇÃO
              </th>

              <th width="68%" className="subtitle">
                TIPO
              </th>

              <th width="2%" />
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <th
                  colSpan="17"
                  style={{ margin: '10px', textAlign: 'center' }}
                >
                  <LinearProgress id="loading" variant="query" />
                </th>
              </tr>
            )}

            {mainContent?.length ? (
              mainContent.map((discard) => (
                <>
                  <tr key={discard.id}>
                    <td className="p12">
                      <Link
                        onClick={() => {
                          setDiscards(discard);
                          toggleDiscardTypeModal();
                        }}
                      >
                        {ValidationLength(discard.description || '-', 25)}
                      </Link>
                    </td>
                    
                    <td className='lastChildRender'>{!validGroup ? removeDuplicate(discard.type).map((item) => <div>{item.description}<p>,</p></div>) : removeDuplicate(discard?.type)?.map((item) => <div>{item?.type?.description}<p>,</p></div>)}</td>

                    <td width="2%">
                      <IconButton
                        aria-label="delete"
                        onClick={() => (
                          handleDialogClickOpen(), setDeleteData(discard)
                        )}
                        style={{ padding: 0, outline: 0 }}
                      >
                        <DeleteOutline className="deleteIcon" />
                      </IconButton>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="4">
                      <hr />
                    </td>
                  </tr>
                </>
              ))
            ) : (
              <tr>
                <th
                  colSpan="13"
                  style={{ margin: '10px', textAlign: 'center' }}
                >
                  Nada foi encontrado
                </th>
              </tr>
            )}
          </tbody>
        </table>

        <div className="pagination">
          <Pagination
            count={totalPages}
            onChange={(event, page) =>
              setCallSettings({ ...callSettings, page })
            }
            variant="outlined"
            shape="rounded"
            size="small"
            color="primary"
          />

          <ItemsPerPage
            numberOfElements={numberOfElements}
            size={totalElements}
          />
        </div>

        <Modal
          className="defaultModal modalRegisterContainer"
          open={discardTypeModal}
          onClose={toggleDiscardTypeModal}
          aria-labelledby="Storage Location Modal"
        >
          <DiscardTypeForm
            isModal
            redirectPath={null}
            onClose={toggleDiscardTypeModal}
            setUpdateList={setUpdateList}
          />
        </Modal>

        <Dialog
          fullScreen={fullScreen}
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            className="modalHeader navyBlue"
            style={{ fontWeight: 'bold', cursor: 'move', fontFamily: 'Lato' }}
            id="draggable-dialog-title"
          >
            <Typography>
              Deseja realmente excluir esse Tipo de descarte?
            </Typography>
          </DialogTitle>

          <DialogContent className="modalContent">
            <Typography>
              Esta ação não pode ser desfeita. Deseja continuar?
            </Typography>
          </DialogContent>

          <DialogActions className="justifyCenter">
            <Button
              className="defaultButton backButton"
              design="outlined"
              onClick={handleDialogClose}
              label="Cancelar"
              color="primary"
            />
            <Button
              className="defaultButton submitButton"
              autoFocus
              design="contained"
              label="Confirmar"
              onClick={(e) => handleDelete()}
              color="primary"
            />
          </DialogActions>
        </Dialog>

        <Snackbar
          open={deleteSuccess}
          autoHideDuration={2000}
          onClose={() => handleCloseAll(handleDeleteSuccess)}
        >
          <Alert
            onClose={() => handleCloseAll(handleDeleteSuccess)}
            severity="success"
          >
            Tipo de descarte deletado com sucesso!
          </Alert>
        </Snackbar>

        <Snackbar
          open={deleteError}
          autoHideDuration={2000}
          onClose={() => handleCloseAll(handleDeleteError)}
        >
          <Alert
            onClose={() => handleCloseAll(handleDeleteError)}
            severity="error"
          >
            Ocorreu um erro ao salvar as informações.
          </Alert>
        </Snackbar>
      </Container>
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(DiscardsActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TipoDeDescarte);
